import { type ButtonProps } from '@/components/ui/Button'
import Link from 'next/link'
import React from 'react'
import type { Page, Post, Project } from '@/payload-types'
import { LinkButton } from '@/components/ui/LinkButton'
import { getCMSLinkHrefAndTabProps } from '@/utilities/getCMSLinkHref'

export type CMSLinkType = {
  variant?: 'inline' | ButtonProps['variant']
  children?: React.ReactNode
  className?: string
  label?: string | null
  newTab?: boolean | null
  reference?: {
    relationTo: 'pages' | 'posts' | 'projects'
    value: Page | Post | Project | string | number
  } | null
  size?: ButtonProps['size'] | null
  type?: 'custom' | 'reference' | null
  url?: string | null
  linkIcon?: 'show' | 'none' | null
}

export const CMSLink: React.FC<CMSLinkType> = (params) => {
  const { size, type, variant = 'inline', children, className, label, linkIcon = 'show' } = params

  const { href, ...props } = getCMSLinkHrefAndTabProps(params)

  if (!href) return null

  /* Ensure we don't break any styles set by richText */
  if (variant === 'inline') {
    return (
      <Link className={className} href={href || ''} {...props}>
        {label && label}
        {children && children}
      </Link>
    )
  }

  return (
    <LinkButton
      {...props}
      size={size}
      variant={variant}
      href={href || ''}
      linkIcon={linkIcon === 'none' ? 'none' : type === 'reference' ? 'internal' : 'external'}
      className={className}
    >
      {label && label}
      {children && children}
    </LinkButton>
  )
}
